import React from 'react';
import { Button as PilotButton } from '../pilot-ui/button';
import { buttonClass, type ButtonSize, type ButtonVariant } from './buttonStyles';

export { buttonClass };
export type { ButtonSize, ButtonVariant };

export interface ButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'title'> {
  variant: ButtonVariant;
  size?: ButtonSize;
  /** Hover help describing the action and its result. */
  title: string;
}

const roleVariant: Record<ButtonVariant, 'default' | 'outline' | 'destructive' | 'link' | 'ghost'> = {
  primary: 'default',
  secondary: 'outline',
  danger: 'destructive',
  link: 'link',
  icon: 'ghost',
};

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant, size, className, type = 'button', ...props },
  ref,
) {
  return (
    <PilotButton
      ref={ref}
      type={type}
      variant={roleVariant[variant]}
      size={size === 'sm' ? 'sm' : size === 'md' ? 'default' : undefined}
      data-shared-button=""
      className={className}
      {...props}
    />
  );
});

export default Button;
